import React, { useState, useContext, useEffect } from "react";
import { useParams } from "react-router-dom";
import "./UAReelsGridLayout.css";
import ReelsGridTopLayout from "./Layout/ReelsGridTopLayout";
import ReelsGridLeftLayout from "./Layout/ReelsGridLeftLayout";
import UserPostCentreLayout from "../../Layout/UserAccountGridCenter"; // ✅ Import UserPostCentreLayout
import { ThemeContext } from "../../../../../context/ThemeContext";
import "../../Styles/ua-common-styles.css";

const ReelsPageUAGridLayout = () => {
  const [selectedProfileId, setSelectedProfileId] = useState(null);
  const { theme } = useContext(ThemeContext);
  const { userid } = useParams();
  const [activetab, setActivetab] = useState(""); // ✅ Changed from "feed" to ""
  const [displayMode, setDisplayMode] = useState("grid"); // ✅ Add displayMode state

  useEffect(() => {
    import(`./Styles/themes/${theme}/themes.css`)
      .then(() => {
        console.log(`Loaded ${theme} styles for UserProfile`);
      })
      .catch(() => {
        console.error(`Theme CSS not found for ${theme}`);
      });
  }, [theme]);

  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <div className={`uaf-page-grid`}>
        {/* ✅ Middle Container - Conditional Rendering */}
        <main className="uaf-middle-container" style={{ marginTop: 70, minHeight: "100vh" }}>
          {activetab !== "" ? (
            // ✅ Render UserPostCentreLayout when activetab is NOT empty
            <UserPostCentreLayout
              pagetype="feed"
              mediaDisplayMode={displayMode}
              userId={userid}
              activetab={activetab}
            />
          ) : (
            // ✅ Render ReelsGridTopLayout when activetab is empty (default view)
            <ReelsGridTopLayout />
          )}
        </main>
      </div>

      {/* Copyright Footer */}
      <div style={{ justifyContent: "center", display: "flex", marginTop: 20 }}>
        <p className="cmn-copyright">
          Oowlet - A Hybrid Model Social Network, Copyright © InitiumNet Technology Pvt Ltd.
        </p>
      </div>
    </div>
  );
};

export default ReelsPageUAGridLayout;
